import { render, staticRenderFns } from "./HotColumnList.vue?vue&type=template&id=531ceec4&scoped=true&"
import script from "./HotColumnList.vue?vue&type=script&lang=js&"
export * from "./HotColumnList.vue?vue&type=script&lang=js&"
import style0 from "./HotColumnList.vue?vue&type=style&index=0&id=531ceec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ceec4",
  null
  
)

export default component.exports